export const CORE_CATEGORIES = [
  "Movies",
  "Movie Quotes",
  "Lord of the Rings",
  "Pokemon",
  "1990s Nostalgia",
  "2000s Nostalgia",
  "Nostalgic Brands",
  "Brand Lore",
  "Logos",
  "Geography",
  "History",
  "General",
  "Pop Culture",
  "Art & Literature",
  "People & Places",
  "Countries",
  "Marvel Movies",
  "Star Wars",
  "Sports Facts",
  "Sports Jerseys",
  "Pacific Northwest Trivia",
  "Harry Potter",
  "Technology",
  "Pop Punk",
  "Rap",
  "Seattle Mariners",
  "Music History",
  "TV Shows",
  "Video Games",
  "Food and Drink",
  "Internet Culture",
  "Science",
  "Space",
  "US States",
  "World Capitals",
  "Maps and Flags",
  "NBA",
  "NFL",
  "MLB",
  "NHL",
  "Olympic Sports",
  "Seattle and Washington State",
  "Toys"
] as const;

export type CoreCategory = (typeof CORE_CATEGORIES)[number];

export const PLAYER_NAMES = ["Cam", "Kodi", "Cody", "Scott", "Riley", "Cole", "Keenan"] as const;

export const PLAYER_COLORS = ["#b8e0d2", "#f7d6bf", "#c7d9ff", "#f3c5d7", "#d4e6a5", "#cab8ff", "#ffd972"] as const;

export const REACTIONS = ["nailed-it", "brutal", "lol", "dispute", "classic"] as const;
